const notificationsBreadcrumbsRoutes = {
  '/notifications': 'Notifications',
};

export { notificationsBreadcrumbsRoutes };
